module.exports = __webpack_public_path__ + "static/media/RecomendaBH.8cce4c75.jpg";